import React, { useLayoutEffect, useState } from "react";
import { DefaultMap, DefaultMarker } from "./default-map";
import { BusinessApi } from "../../lib-api";
import { apiConfiguration } from "../../api-configuration";
import { createRoot } from "react-dom/client";

const api = new BusinessApi(apiConfiguration);

const BusinessMap: React.FC<{
  categoryId: string;
  latitude: number;
  longitude: number;
}> = (props) => {
  const [markers, setMarkers] = useState<DefaultMarker[]>();

  const getResult = async () => {
    const result = await api.getBusinessMapData({
      categoryId: props.categoryId,
    });
    setMarkers(
      result.businessMapEntries.map<DefaultMarker>((x) => {
        return {
          data: [x.name, x.address, `${x.zipCode} ${x.city}`],
          position: [x.latitude!, x.longitude!],
          url: x.url,
        };
      })
    );
  };

  useLayoutEffect(() => {
    getResult();
  }, []);

  return (
    <>
      {markers && markers.length > 0 && (
        <DefaultMap
          markers={markers}
          latitude={props.latitude}
          longitude={props.longitude}
        />
      )}
    </>
  );
};

const element = document.getElementsByTagName("business-map");
if (element.length == 1) {
  const root = createRoot(element[0]);
  root.render(
    <BusinessMap
      categoryId={element[0].getAttribute("data-categoryId")!.valueOf()}
      latitude={Number(element[0].getAttribute("data-latitude")!.valueOf())}
      longitude={Number(element[0].getAttribute("data-longitude")!.valueOf())}
    />
  );
}
